import React, { Component } from "react";
import PropTypes from "prop-types";
import "./tab.styles.css";

class Tab extends Component {
  static propTypes = {
    activeTab: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  onClick = () => {
    const { label, onClick } = this.props;
    onClick(label);
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const { label, onClick } = this.props;
      onClick(label);
    }
  };

  render() {
    const {
      onClick,
      props: { activeTab, label },
    } = this;

    let className = "tab-list-item";

    if (activeTab === label) {
      className += " tab-list-active";
    }

    return (
      <li
        className={className}
        onClick={onClick}
        onKeyDown={this.handleKeyDown}
        tabIndex="0"
      >
        {label}
      </li>
    );
  }
}

export default Tab;
